'use strict';

import { base, Component, PropTypes, update, sub, fromJS, toJS, mq, ReactChildren } from 'core';

class PageWrapper extends Component {

    styles = {
        page: { height: '100%' },
        inner: { height: '100%' }
    }
    render() {

        const { children } = this.props;

        return (
            <div style={ this.styles.page } {...this.props}>
                <div style={ this.styles.inner } className="page_wrapper-inner">
                    { children }
                </div>
            </div>
        );
    }
}

export default PageWrapper



// WEBPACK FOOTER //
// ./ui/c/layout/pageWrapper.jsx